module.exports = __webpack_public_path__ + "img/logo_healtri1.8027f5c7.png";